module.exports = __webpack_public_path__ + "img/search_icon.878c7769.png";